import React, { useState, useEffect } from 'react';
import styles from './WhatsNewModal.module.css';

const CURRENT_VERSION = '2.01';

const WhatsNewModal = ({ user }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!user) return;

    const seenVersion = localStorage.getItem(`zenBidTracker_whatsNew_${user.uid}`);
    if (seenVersion !== CURRENT_VERSION) {
      // Small delay so app loads first
      setTimeout(() => setIsVisible(true), 500);
    }
  }, [user]);

  const handleDismiss = () => {
    if (user) {
      localStorage.setItem(`zenBidTracker_whatsNew_${user.uid}`, CURRENT_VERSION);
    }
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.versionBadge}>v{CURRENT_VERSION}</div>
          <h2 className={styles.title}>What's New in ZenBidTracker</h2>
          <p className={styles.subtitle}>Check out the latest features and improvements!</p>
        </div>

        <div className={styles.content}>
          <div className={styles.featureSection}>
            <h3 className={styles.sectionTitle}>Export & Import</h3>
            <ul className={styles.featureList}>
              <li>
                <span className={styles.featureIcon}>📊</span>
                <div>
                  <strong>Export to Excel</strong>
                  <p>Export your bids to Excel (.xlsx) format with all data preserved</p>
                </div>
              </li>
              <li>
                <span className={styles.featureIcon}>📥</span>
                <div>
                  <strong>Import from Excel/CSV</strong>
                  <p>Bulk import bids from spreadsheets with automatic field mapping</p>
                </div>
              </li>
              <li>
                <span className={styles.featureIcon}>📄</span>
                <div>
                  <strong>Download Template</strong>
                  <p>Get a pre-formatted template to easily prepare your import data</p>
                </div>
              </li>
            </ul>
          </div>

          <div className={styles.featureSection}>
            <h3 className={styles.sectionTitle}>Attachments</h3>
            <ul className={styles.featureList}>
              <li>
                <span className={styles.featureIcon}>📎</span>
                <div>
                  <strong>Bid Attachments</strong>
                  <p>Attach files and URLs to any bid for easy reference</p>
                </div>
              </li>
              <li>
                <span className={styles.featureIcon}>🔗</span>
                <div>
                  <strong>Sub-Bid Attachments</strong>
                  <p>Attach documents directly to sub-bids for better organization</p>
                </div>
              </li>
            </ul>
          </div>

          <div className={styles.featureSection}>
            <h3 className={styles.sectionTitle}>UI Improvements</h3>
            <ul className={styles.featureList}>
              <li>
                <span className={styles.featureIcon}>📐</span>
                <div>
                  <strong>Compact Toolbar</strong>
                  <p>Streamlined toolbar with smaller, more efficient controls</p>
                </div>
              </li>
              <li>
                <span className={styles.featureIcon}>📈</span>
                <div>
                  <strong>Smoother Analytics</strong>
                  <p>Date filtering no longer shows loading screen - data updates seamlessly</p>
                </div>
              </li>
              <li>
                <span className={styles.featureIcon}>🎯</span>
                <div>
                  <strong>Resizable Columns</strong>
                  <p>Drag column borders to customize table layout</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className={styles.footer}>
          <button className={styles.dismissButton} onClick={handleDismiss}>
            Got it, let's go!
          </button>
        </div>
      </div>
    </div>
  );
};

export default WhatsNewModal;
